import { WorkoutCompleted } from '@sworkit/api';
import { query, collection, where, onSnapshot, getDocs, doc, setDoc } from 'firebase/firestore';
import { fst as firestore } from './firebase';
import { getLoggedInUserId } from './firestore-user';

export function getCollectionWorkoutsCompletedListener(
  collectionSlugOriginal: string,
  callback: (workouts: WorkoutCompleted[]) => void
) {
  const uid = getLoggedInUserId();
  if (!uid || !firestore) return;
  const collectionSlug = getChallengeSlug(collectionSlugOriginal);
  const q = query(collection(firestore, `/users/${uid}/collectionWorkoutsCompleted`),
    where('collectionSlug', '==', collectionSlug))

  return onSnapshot(q, (snap) => {
    const completedWorkouts = snap.docs.map(
      (doc) => doc.data() as WorkoutCompleted
    );
    callback(completedWorkouts);
  });
}

export async function getCollectionWorkoutsCompleted(
  collectionSlugOriginal: string
) {
  const uid = getLoggedInUserId();
  if (!uid || !firestore) return;
  const collectionSlug = getChallengeSlug(collectionSlugOriginal);
  const snap = await getDocs(query(collection(firestore, `/users/${uid}/collectionWorkoutsCompleted`),
    where('collectionSlug', '==', collectionSlug)))
  const completed = snap.docs.map((doc) => doc.data() as WorkoutCompleted);
  const completedCount = completed.filter((doc) => doc.completed).length;
  return completedCount;
}

export async function markCollectionWorkoutComplete(
  collectionSlugOriginal: string,
  workoutSlug: string,
  workoutLogId?: string,
  minutesCompleted?: number
) {
  const uid = getLoggedInUserId();
  if (!uid || !firestore || (typeof minutesCompleted === 'number') && minutesCompleted <= 1) return;
  const collectionSlug = getChallengeSlug(collectionSlugOriginal);
  const collectionCompleted: WorkoutCompleted = {
    completed: true,
    collectionSlug,
    workoutSlug,
    workoutLogId,
    timestamp: Date.now(),
  };
  const documentId = `${collectionSlug}-${workoutSlug}`;
  return setDoc(doc(firestore, `users/${uid}/collectionWorkoutsCompleted/${documentId}`), collectionCompleted, { merge: true });
}

export function markCollectionWorkoutIncomplete(
  collectionSlugOriginal: string,
  workoutSlug: string
) {
  const uid = getLoggedInUserId();
  if (!uid || !firestore) return;
  const collectionSlug = getChallengeSlug(collectionSlugOriginal);
  return deleteCompletedCollectionWorkout(collectionSlug, workoutSlug);
}

async function deleteCompletedCollectionWorkout(
  collectionSlug: string,
  workoutSlug: string
) {
  const uid = getLoggedInUserId();
  if (!uid || !firestore) return;
  const update: Partial<WorkoutCompleted> = { completed: false };
  const documentId = `${collectionSlug}-${workoutSlug}`;
  return setDoc(doc(firestore, `users/${uid}/collectionWorkoutsCompleted/${documentId}`), update, { merge: true });
}

export async function resetWorkoutsCompletedCollection(collectionSlug: string) {
  const uid = getLoggedInUserId();
  const slug = getChallengeSlug(collectionSlug)
  if (!uid || !firestore) return;
  const queryResult = await getDocs(query(collection(firestore, `/users/${uid}/collectionWorkoutsCompleted`),
    where('collectionSlug', '==', slug)))
  const promises = queryResult.docs.map((doc: any) =>
    deleteCompletedCollectionWorkout(
      slug,
      (doc.data() as WorkoutCompleted).workoutSlug
    )
  );
  return Promise.all(promises);
}

function getChallengeSlug(slug: string) {
  const year = new Date().getFullYear();
  const slugMap: { [slug: string]: string } = {
    'january-challenge': `${year}-january-challenge`,
    'february-challenge': `${year}-february-challenge`,
    'march-challenge': `${year}-march-challenge`,
    'april-challenge': `${year}-april-challenge`,
    'may-challenge': `${year}-may-challenge`,
    'june-challenge': `${year}-june-challenge`,
    'july-challenge': `${year}-july-challenge`,
    'august-challenge': `${year}-august-challenge`,
    'september-challenge': `${year}-september-challenge`,
    'october-challenge': `${year}-october-challenge`,
    'november-challenge': `${year}-november-challenge`,
    'december-challenge': `${year}-december-challenge`,
  };
  if (slugMap[slug]) {
    return slugMap[slug];
  } else {
    return slug;
  }
}
